import { render } from "./ColumnDetail.vue?vue&type=template&id=9902666c&scoped=true"
import script from "./ColumnDetail.vue?vue&type=script&lang=js"
export * from "./ColumnDetail.vue?vue&type=script&lang=js"

import "@/assets/css/style_parts.css?vue&type=style&index=0&id=9902666c&lang=css&scoped=true"
import "@/assets/css/style_column.css?vue&type=style&index=1&id=9902666c&lang=css&scoped=true"
import "./ColumnDetail.vue?vue&type=style&index=2&id=9902666c&scoped=true&lang=css"

import exportComponent from "/Users/a03/development/vue/mog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9902666c"]])

export default __exports__